import { HttpResponse } from "@angular/common/http";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Constants } from "src/app/app.constants";
import { AppService } from "src/app/app.service";
import { StorageService } from "src/app/app.storage.service";
import { CommonService } from "src/app/common.service";
import { AttendanceConstant } from "../attendance.constant";
import { AttendanceService } from "../attendance.service";

declare var moment: any;
declare var $: any;
@Component({
    selector: 'app-leave-application',
    templateUrl: './leave-application.component.html',
    styleUrls: ['./leave-application.component.css']
})

export class LeaveApplicationComponent{
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private attendanceService: AttendanceService,
        private appService: AppService,
        private commonService : CommonService,
        private storageService : StorageService,
        private changeDetectRef: ChangeDetectorRef,
        
    ){ 
        window['leaveApplicationCompRef'] = {comp: this}
    }


    leaveTypeListWithFlag: any[] = [];
    selectedLeaveType: any = null;
    startTime: number = null;
    endTime: number = null;
    totalLeaves: number  = 1;
    reasonForLeave: string = null;
    userLeaveSummaries : any;
    paramSubscription: Subscription;
    previousCompUrl: string = "home/attendance/my-attendance";
    dayList : any [] = AttendanceConstant.ATTENDANCE_DAYTYPE_LIST;
    selectedDayType: any = null;
    userId : any ;
    isdisabled : boolean = false;
    singleDate : boolean = false;
   async ngOnInit(){
    var obj= {};
    obj['showLeave'] = false;
    obj['showMarkAttendance'] = false;
    this.attendanceService.showLeaveApplicationSubject.next(obj);

    let userInfo = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.USER_INFO);
    if(userInfo.id){
        this.userId = userInfo.id;
    }
        this.paramSubscription = this.activeRoute.queryParams.subscribe((param)=>{
            if(param && param.currentRoute){
                this.previousCompUrl = param.currentRoute;
            }
        })
        this.getLeaveSummary();
        let leaveTypeList = await this.appService.getAttendnaceTypeObject().catch(()=>{
           
        });
        if(!$.isEmptyObject(leaveTypeList)){
            for(let obj of leaveTypeList['list']){
                if(obj.isApplicable && obj.status){
                 this.leaveTypeListWithFlag = [...this.leaveTypeListWithFlag,obj];
                 // this.leaveTypeListWithFlag.push(obj)
                }
            }
            this.selectedLeaveType = this.leaveTypeListWithFlag[0];
        }
     
      
       this.initializeDatepicker();
    }

    ngOnDestroy(){
        if(this.paramSubscription){
            this.paramSubscription.unsubscribe();
        }
    }

    navigateToAttendance(){
        var obj= {};
        obj['showLeave'] = true;
        obj['showMarkAttendance'] = true;
        this.attendanceService.showLeaveApplicationSubject.next(obj);
        this.router.navigate([this.previousCompUrl]);
    }

    initializeDatepicker(){
        var scope = this;
        // let scope = window['leaveApplicationCompRef'].comp;
        $(function () {
            var start = moment().add(1,'days').startOf('day');
            var end = moment().add(1,'days').endOf('day');

            function cb(start, end) {

               console.log(scope.singleDate)
               
                if(!scope.singleDate){
                    $("#reportrange input").val(start.format("DD/MM/YYYY") + " - "+ end.format("DD/MM/YYYY"));
                    scope.startTime = start.toDate().getTime() / 1000 | 0;
                    scope.endTime = end.toDate().getTime() / 1000 | 0;
                    scope.totalLeaves = scope.commonService.getDifferenceOfTwoTimestamp(scope.startTime,scope.endTime)
                }
                else{
                    $("#reportrange input").val(start.format("DD/MM/YYYY"));
                    scope.startTime = start.toDate().getTime() / 1000 | 0;
                    scope.totalLeaves = 1 ;
                }
             
            //    console.log(scope.startTime, scope.endTime);
               
            
            //    scope.totalLeaves = scope.totalLeaves +1;
               scope.changeDetectRef.detectChanges();
             
            }
            
          
            $("#reportrange").daterangepicker({
                showDropdowns: true,
                singleDatePicker: scope.singleDate,
                //parentEl: '.singleDatepickerClasss',
                // parentEl: '.singleDatepickerClasss',
                opens: 'left',
                startDate: start,
                endDate: end,
                minDate:start,
                maxDate: moment().endOf('day').add(60, 'days'),
                locale: {
                    format: "DD/MM/YYYY"
                },
            
            },
                cb
            );
             
            cb(start, end);
           

        });
     
    }

    keydown(event){
        event.stopImmediatePropagation();
        event.returnValue = false;
    }

    onLeaveApply(){
       
        var CurrentDate =moment().startOf('day').toDate().getTime() / 1000 | 0;
        var regexNumber = /^-?(0|[1-9]\d*)?$/
        let leaveData = {};
        if(!this.selectedLeaveType){
            this.appService.showInfoPopup("Info", "Please select leave type");
            return;
        }
        leaveData['leaveType'] = this.selectedLeaveType.id;
        if(this.selectedLeaveType.isFullDay || this.selectedLeaveType.isHalfDay){
            if(!this.selectedDayType){
                this.appService.showInfoPopup("Info", "Please select Full day or Half day");
                return;
            }
           
        }
        if(!this.startTime || !this.endTime){
            this.appService.showInfoPopup("Info", "Please select the from and to");
            return;
        }else{
            if(this.startTime < CurrentDate){
                this.appService.showInfoPopup("Info", "You cannot apply leave for previous date!");
                return;
            }
             var date = new Date(this.startTime*1000);
             var month = date.getMonth()+1;
            //  console.log(month)
             let monthleavesList = this.getMonthLeaves(month);
             if(monthleavesList && monthleavesList.length>0){
                for(let obj of monthleavesList){
                    if(this.startTime >= obj.fromTimestamp && this.endTime <=obj.toTimestamp){
                       this.appService.showInfoPopup("Info", "Leaves are already applied");
                      return;  
                    }
                }
             }
        
          
        }
     
        leaveData['fromTimestamp'] = this.startTime;
        leaveData['toTimestamp'] = this.endTime;

        if(!this.totalLeaves){
            this.appService.showInfoPopup("Info", "Please enter the no of days");
            return;
        }
        else {
            if (regexNumber.test(this.totalLeaves.toString()) === true) {
                leaveData['count'] = this.totalLeaves;
            } else {
                this.appService.showInfoPopup("Info", "Please enter days of number type.");
                return;
            }
        }

        var trimmedReason = "";
        if(!this.reasonForLeave){
            this.appService.showInfoPopup("Info", "Please enter the reason for leave");
            return;
        }else{
            trimmedReason = this.reasonForLeave.trim();
            if(!trimmedReason){
                this.appService.showInfoPopup("Info", "Please enter the reason for leave");
                return;  
            }else{
                leaveData['reason'] = trimmedReason;
            }
        }
       


        this.attendanceService.saveLeave(leaveData)
            .subscribe((res: HttpResponse<any>)=>{
                this.appService.showSuccessPopup("Success","Leave applied successfully.")
                var obj= {};
                obj['showLeave'] = true;
                obj['showMarkAttendance'] = true;
                this.attendanceService.showLeaveApplicationSubject.next(obj);
               this.router.navigate(['home/attendance/leave-summary']);
            }, (err)=>{
                this.appService.showErrorPopup("Error","Something went wrong.")
            })

    }
leaveInfo: any;
    getLeaveSummary(timestamp?){
       
        this.attendanceService.getLeaveSummary(timestamp)
            .subscribe((res: HttpResponse<any>) =>{
              
                // console.log(res.body);
                this.userLeaveSummaries = res.body.userLeaveSummaries;
                this.getLeaveInfo();
            }, (err)=>{
                console.log(err);
            })
    }
    getLeaveInfo(){
        for(let userSummary of this.userLeaveSummaries){
            if( this.userId== userSummary.userInfo.id){
                this.leaveInfo = userSummary.leaveInfo;
                // console.log(this.leaveInfo)
            }
           }
    }
    getMonthLeaves(month){
       
        let monthlyLeaves = this.leaveInfo.monthlyLeaves;
        let list =[];
        if(monthlyLeaves[month] && monthlyLeaves[month].leaveByType){
            let leavesByType = monthlyLeaves[month].leaveByType;
            if(leavesByType && Object.keys(leavesByType).length>0){
                for(let key of  Object.keys(leavesByType)){
                    // list.push(leavesByType[key])
                   
                    list.push.apply(list, leavesByType[key])
                }
            }
            // console.log(list);
          
            list = list.sort((a, b) => { return a.fromTimestamp - b.fromTimestamp})
        }
   
       
       
        // console.log(list)
        return list;
    }
    
    changeLeaveType(selectedLeaveType){
        this.singleDate = false;
        if(selectedLeaveType){
            // if(selectedLeaveType.isFullDay && selectedLeaveType.isHalfDay){
            //     this.selectedDayType = this.dayList[0];
            //     return
            // }
            if(selectedLeaveType.isHalfDay && !selectedLeaveType.isFullDay){
                this.selectedDayType = this.dayList[1];
                this.isdisabled = true;
                this.singleDate = true
            }
            else if (selectedLeaveType.isFullDay && !selectedLeaveType.isHalfDay){
                this.selectedDayType = this.dayList[0];
                this.isdisabled = true
                this.singleDate = false;
            }
        }
        // console.log(this.selectedDayType);
        this.initializeDatepicker();
    
    }
    changeDay(selectedDayType){
        if(selectedDayType && selectedDayType.key==1){
            this.singleDate = false;
        }else{
            this.singleDate = true
        }
        this.initializeDatepicker();

    }

}